import { PlusCircle } from "react-feather";
import DataTable from "../Generic/DataTable";
import { useContext, useEffect, useState } from "react";
import { tenantContext } from "../Main/contexts";
import {
    CreateUser,
    DeleteUser,
    GetUser,
    GetUserResponse,
    GetUsers,
    UpdateUser,
    UsersGridListDTO,
    UsersListDTO,
} from "./TenantAPI";
import Loading from "../Generic/loading";
import { dataColumn } from "../Generic/DataTable";
import { sortByField, SortEnquiriesParams } from "../Logic/sort";
import TextBox from "../Generic/TextBox";
import NumberBox from "../Generic/NumberBox";
import ToggleSwitch from "../Generic/ToggleSwitch";
import TextArea from "../Generic/TextArea";
import Dropdown from "../Generic/DropDown";
import { Departments, GetDepartmentResponse, GetDepartments } from "../Logic/department";
import { GetGlobalRoles, GlobalRolesListItemDTO } from "../Roles/TenantAPI";
import { lengthIsLessThan, lengthIsLessThanAndIsNotEmpty, numberIsBetween } from "../Logic/validationRules";

function Profile() {
    const { selectedTenant } = useContext(tenantContext);
    const [isLoading, setIsLoading] = useState<Boolean>(true);
    const [allUsers, setAllUsers] = useState<Array<UsersListDTO>>([]);
    const [filtertedGridaData, setFiltertedGridaData] = useState<Array<UsersGridListDTO>>([]);
    const [sortBy, setSortBy] = useState<SortEnquiriesParams>();
    const [selectedItem, setSelectedItem] = useState("");
    const [selectedUser, setSelectedUser] = useState<GetUserResponse | undefined>(undefined);
    const [departments, setDepartments] = useState<Array<Departments>>([]);
    const [globalRoles, setGlobalroles] = useState<Array<GlobalRolesListItemDTO>>([]);
    const [isNewUser, setIsNewUser] = useState<Boolean>(true);
    const [validationErrors, setValidationErrors] = useState<Array<string>>([]);

    useEffect(() => {
        (async () => {
            if (selectedTenant) {
                const user_results = GetUsers(selectedTenant.token);
                const departments_results = GetDepartments(selectedTenant.token);
                const globalRoles_results = GetGlobalRoles(selectedTenant.token);
                Promise.all([user_results, departments_results, globalRoles_results]).then(results => {
                    if (results[0].isOk) {
                        setAllUsers(results[0].data?.users!);

                        let filtertedList = results[0]
                            .data!.users!.slice()
                            .sort((a, b) => {
                                if (a.blocked !== b.blocked) return a.blocked ? 1 : -1;
                                return (a.firstname ?? "").localeCompare(b.firstname ?? "");
                            })
                            .map(user => {
                                return {
                                    id: user.id,
                                    userName: user.firstname + " " + user.lastname,
                                    blocked: user.blocked,
                                    globalRole: user.globalRole,
                                    department: user.department,
                                };
                            });
                        setFiltertedGridaData(filtertedList);
                    }
                    if (results[1].isOk) {
                        let depts = results[1].data?.items!;
                        depts.sort((a, b) => a.name.localeCompare(b.name));
                        depts.unshift({ id: 0, name: "[No Department]" });
                        setDepartments(depts);
                    }
                    if (results[2].isOk) {
                        setGlobalroles(results[2].data?.items!);
                    }
                    setIsLoading(false);
                });
            }
        })();
    }, [selectedTenant]);

    let AllColumns: dataColumn<UsersGridListDTO>[] = [
        {
            title: <>User Name</>,
            toolTip: "name",
            key: "username",
            getData: (data: UsersGridListDTO) => {
                return <>{data.userName}</>;
            },
            width: "50%",
            canResize: false,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    handleHeaderClick("userName");
                },
                displayIcon: false,
            },
            textAlignment: "left",
            minWidth: "60px",
        },
        {
            title: <>Role</>,
            toolTip: "role",
            key: "role",
            getData: (data: UsersGridListDTO) => {
                return <>{data.globalRole}</>;
            },
            width: "10%",
            canResize: false,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    handleHeaderClick("globalRole");
                },
                displayIcon: false,
            },
            textAlignment: "left",
            minWidth: "60px",
        },
        {
            title: <>Department</>,
            toolTip: "department",
            key: "department",
            getData: (data: UsersGridListDTO) => {
                return <>{data.department}</>;
            },
            width: "40%",
            canResize: false,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    handleHeaderClick("department");
                },
                displayIcon: false,
            },
            textAlignment: "left",
            minWidth: "60px",
        },
    ];

    const handleHeaderClick = (fieldName: string): any => {
        let sortO = sortBy;
        if (!sortO) {
            sortO = {
                orderBy: fieldName,
                desc: false,
            };
        } else {
            sortO.orderBy = fieldName;
            sortO.desc = sortO.desc ? false : true;
        }
        let updatedGrids = sortByField(filtertedGridaData, fieldName, sortO.desc);
        setFiltertedGridaData(updatedGrids);
        setSortBy(sortO);
    };

    function OnFilter(filterValue: string) {
        let filtertedList = allUsers.map(user => {
            return {
                id: user.id,
                userName: user.firstname + " " + user.lastname,
                blocked: user.blocked,
                globalRole: user.globalRole,
                department: user.department,
            };
        });
        let filtered = filtertedList.filter(
            x =>
                x.userName?.toLowerCase().indexOf(filterValue.toLowerCase()) >= 0 ||
                x.department?.toLowerCase().indexOf(filterValue.toLowerCase()) >= 0 ||
                x.globalRole?.toLowerCase().indexOf(filterValue.toLowerCase()) >= 0,
        );
        setFiltertedGridaData(filtered);
    }
    async function getUserInfo(id: string) {
        if (selectedTenant) {
            setSelectedItem(id);
            const result = await GetUser(selectedTenant.token, parseInt(id));
            if (result.isOk) {
                setSelectedUser({ ...defaultUser, ...result.data });
                setIsNewUser(false);
            }
        }
    }
    const isUserBlocked = (item: UsersGridListDTO): string => {
        return item.blocked ? " blocked " : "";
    };
    let defaultUser = {
        id: 0,
        firstName: "",
        lastName: "",
        externalUserID: "",
        email: "",
        telephone: "",
        facsimile: "",
        mobile: "",
        shiftLength: 0,
        blocked: false,
        disableAssignment: false,
        legacyUserSettings: "",
        departmentID: 0,
        legacyRoleID: 1,
        globalRoleID: 1,
    };
    function addUser() {
        setSelectedUser(defaultUser);
        setIsNewUser(true);
    }

    async function createUser() {
        if (isValidUser()) {
            if (selectedTenant && selectedUser) {
                const result = await CreateUser(selectedTenant.token, selectedUser.id, selectedUser);
                if (result.isOk) {
                    const user_results = await GetUsers(selectedTenant.token);
                    if (user_results.isOk) {
                        setAllUsers(user_results.data?.users!);
                    }
                    let filtertedList = user_results.data!.users!.map(user => {
                        return {
                            id: user.id,
                            userName: user.firstname + " " + user.lastname,
                            blocked: user.blocked,
                            globalRole: user.globalRole,
                            department: user.department,
                        };
                    });
                    setFiltertedGridaData(filtertedList);
                    setIsNewUser(false);
                    alert("User Created");
                } else if (!result.isOk && result.validationErrors) {
                    alert(Object.values(result.validationErrors.errors));
                    setIsNewUser(true);
                }
            }
        }
    }

    async function deleteUser() {
        if (selectedUser?.disableAssignment == false || selectedUser?.blocked == false) {
            alert("Cannot delete an active User, Please block and disable assignment.");
            return;
        }

        let confirmDelete = window.confirm("Are you sure you want to delete this User?");
        if (confirmDelete && selectedTenant && selectedUser && selectedUser.id) {
            const result = await DeleteUser(selectedTenant.token, selectedUser.id);
            if (result.isOk) {
                const user_results = await GetUsers(selectedTenant.token);
                setAllUsers(user_results.data?.users!);

                let filtertedList = user_results.data!.users!.map(user => {
                    return {
                        id: user.id,
                        userName: user.firstname + " " + user.lastname,
                        blocked: user.blocked,
                        globalRole: user.globalRole,
                        department: user.department,
                    };
                });
                setFiltertedGridaData(filtertedList);
                alert("User deleted");
                setSelectedUser(undefined);
            }
        }
    }

    const updateValue = (field: string, value: any) => {
        let uUser = JSON.parse(JSON.stringify(selectedUser));
        uUser[field] = value;
        setSelectedUser(uUser);
    };
    const updateBooleanValue = (field: string, value: boolean) => {
        let uUser = JSON.parse(JSON.stringify(selectedUser));
        uUser[field] = value;
        setSelectedUser(uUser);
    };

    const updateUser = async () => {
        if (isValidUser()) {
            if (selectedTenant && selectedUser && selectedUser.id) {
                const result = await UpdateUser(selectedTenant.token, selectedUser.id, selectedUser);
                if (!result.isOk && result.validationErrors) {
                    if (Object.keys(result.validationErrors.errors).some((e: any) => e.includes("DepartmentID"))) {
                        alert("The selected department is invalid, please select a valid department.");
                        return;
                    }
                    alert(Object.values(result.validationErrors.errors));
                } else if (result.isOk) {
                    const user_results = await GetUsers(selectedTenant.token);
                    if (user_results.isOk) {
                        setAllUsers(user_results.data?.users!);
                    }
                    let filtertedList = user_results.data!.users!.map(user => {
                        return {
                            id: user.id,
                            userName: user.firstname + " " + user.lastname,
                            blocked: user.blocked,
                            globalRole: user.globalRole,
                            department: user.department,
                        };
                    });
                    setFiltertedGridaData(filtertedList);
                    alert("user Updated");
                }
            }
        }
    };
    const isValidUser = (): boolean => {
        let validationErrors = [];
        if (!lengthIsLessThanAndIsNotEmpty(selectedUser?.externalUserID, 50)) {
            validationErrors.push("externalUserID");
        }
        if (!lengthIsLessThanAndIsNotEmpty(selectedUser?.firstName, 50)) {
            validationErrors.push("firstName");
        }
        if (!lengthIsLessThan(selectedUser?.lastName, 50)) {
            validationErrors.push("lastName");
        }
        if (!lengthIsLessThan(selectedUser?.email, 50)) {
            validationErrors.push("email");
        }
        if (!lengthIsLessThan(selectedUser?.telephone, 20)) {
            validationErrors.push("telephone");
        }
        if (!lengthIsLessThan(selectedUser?.facsimile, 20)) {
            validationErrors.push("facsimile");
        }
        if (!lengthIsLessThan(selectedUser?.mobile, 20)) {
            validationErrors.push("mobile");
        }
        if (!numberIsBetween(selectedUser?.shiftLength, 1440)) {
            validationErrors.push("shiftLength");
        }
        if (!lengthIsLessThan(selectedUser?.legacyUserSettings, 1000)) {
            validationErrors.push("legacyUserSettings");
        }
        if (selectedUser?.departmentID == undefined) {
            validationErrors.push("departmentID");
        }
        if (validationErrors.length > 0) {
            setValidationErrors(validationErrors);
            return false;
        }
        return true;
    };

    return (
        <>
            <div className="topSection">
                <div className="sectionHeader">
                    <PlusCircle
                        className="headerIcon"
                        onClick={addUser}
                    ></PlusCircle>{" "}
                    Users
                </div>
                {selectedUser && !isNewUser && (
                    <div>
                        <button
                            className="g-btn-large btn-warning"
                            onClick={deleteUser}
                        >
                            {" "}
                            Delete User
                        </button>{" "}
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        <button
                            className="g-btn-large btn-primary"
                            onClick={updateUser}
                        >
                            {" "}
                            Update User{" "}
                        </button>
                    </div>
                )}
                {selectedUser && isNewUser && (
                    <div>
                        <button
                            className="g-btn-large btn-primary"
                            onClick={createUser}
                        >
                            {" "}
                            Create User{" "}
                        </button>
                    </div>
                )}
            </div>
            <div style={{ display: "flex", flexDirection: "row", height: "calc(100% - 44px)" }}>
                <div
                    className="Users-bodyCol1"
                    style={{ flex: "0 0 500px" }}
                >
                    {isLoading && <Loading></Loading>}
                    {!isLoading && (
                        <>
                            <div className="filterContainer">
                                <div>Filter: </div>
                                <div>
                                    <input
                                        type="text"
                                        style={{ width: "100%" }}
                                        onChange={e => OnFilter(e.currentTarget.value)}
                                    />
                                </div>
                            </div>
                            <DataTable
                                data={filtertedGridaData.slice().sort((a, b) => {
                                    if (a.blocked !== b.blocked) return a.blocked ? 1 : -1;
                                    return (a.userName ?? "").localeCompare(b.userName ?? "");
                                })}
                                columns={AllColumns}
                                onRowClick={(val: string) => {
                                    getUserInfo(val);
                                }}
                                onRowDblClick={() => {}}
                                selectedItem={selectedItem}
                                uniqueIdentifiyer={x => {
                                    return x.id.toString();
                                }}
                                getCustomClass={isUserBlocked}
                            ></DataTable>
                        </>
                    )}
                </div>

                {selectedUser && (
                    <div className="bodyCol2">
                        <div className="optionsRow">
                            <p style={{ marginBottom: "6px", marginTop: "-0px", fontWeight: "bold", fontSize: "12pt" }}>
                                Edit User{" "}
                            </p>
                        </div>
                        <div className="formRow">
                            <TextBox
                                id={"externalUserID"}
                                label="External User Id"
                                value={selectedUser.externalUserID}
                                onChange={(field: string, value: any) => {
                                    updateValue(field, value);
                                }}
                                maxLength={50}
                                requiredIdentifier={true}
                                errorMessage={
                                    validationErrors.find(x => x == "externalUserID")
                                        ? "Field cannot be blank and must be less than 50 characters"
                                        : ""
                                }
                                validationFunc={lengthIsLessThanAndIsNotEmpty}
                            ></TextBox>
                        </div>
                        <div className="formRow">
                            <TextBox
                                id={"firstName"}
                                label="First Name"
                                value={selectedUser.firstName}
                                onChange={(field: string, value: any) => {
                                    updateValue(field, value);
                                }}
                                maxLength={50}
                                requiredIdentifier={true}
                                errorMessage={
                                    validationErrors.find(x => x == "firstName")
                                        ? "Field cannot be blank and must be less than 50 characters"
                                        : ""
                                }
                                validationFunc={lengthIsLessThanAndIsNotEmpty}
                            ></TextBox>
                        </div>
                        <div className="formRow">
                            <TextBox
                                id={"lastName"}
                                label="Last Name"
                                value={selectedUser.lastName}
                                onChange={(field: string, value: any) => {
                                    updateValue(field, value);
                                }}
                                maxLength={50}
                                requiredIdentifier={false}
                                errorMessage={
                                    validationErrors.find(x => x == "lastName")
                                        ? "Field must be less than 50 characters"
                                        : ""
                                }
                                validationFunc={lengthIsLessThan}
                            ></TextBox>
                        </div>
                        <div className="formRow">
                            <TextBox
                                id={"email"}
                                label="Email Address"
                                value={selectedUser.email}
                                onChange={(field: string, value: any) => {
                                    updateValue(field, value);
                                }}
                                maxLength={50}
                                errorMessage={
                                    validationErrors.find(x => x == "email")
                                        ? "Field must be less than 50 characters"
                                        : ""
                                }
                                validationFunc={lengthIsLessThan}
                            ></TextBox>
                        </div>
                        <div className="formRow">
                            <TextBox
                                id={"telephone"}
                                label="Telephone"
                                value={selectedUser.telephone}
                                onChange={(field: string, value: any) => {
                                    updateValue(field, value);
                                }}
                                maxLength={20}
                                errorMessage={
                                    validationErrors.find(x => x == "telephone")
                                        ? "Field must be less than 20 characters"
                                        : ""
                                }
                                validationFunc={lengthIsLessThan}
                            ></TextBox>
                        </div>
                        <div className="formRow">
                            <TextBox
                                id={"facsimile"}
                                label="Facsimile"
                                value={selectedUser.facsimile}
                                onChange={(field: string, value: any) => {
                                    updateValue(field, value);
                                }}
                                maxLength={20}
                                errorMessage={
                                    validationErrors.find(x => x == "facsimile")
                                        ? "Field must be less than 20 characters"
                                        : ""
                                }
                                validationFunc={lengthIsLessThan}
                            ></TextBox>
                        </div>
                        <div className="formRow">
                            <TextBox
                                id={"mobile"}
                                label="Mobile"
                                value={selectedUser.mobile}
                                onChange={(field: string, value: any) => {
                                    updateValue(field, value);
                                }}
                                maxLength={20}
                                errorMessage={
                                    validationErrors.find(x => x == "mobile")
                                        ? "Field must be less than 20 characters"
                                        : ""
                                }
                                validationFunc={lengthIsLessThan}
                            ></TextBox>
                        </div>
                        <div className="formRow">
                            <NumberBox
                                id={"shiftLength"}
                                label="Shift Length"
                                value={selectedUser.shiftLength}
                                onChange={(field: string, value: any) => {
                                    updateValue(field, value);
                                }}
                                maxLength={1440}
                                errorMessage={
                                    validationErrors.find(x => x == "shiftLength")
                                        ? "Value must be between  1 and 1440"
                                        : ""
                                }
                                validationFunc={numberIsBetween}
                            ></NumberBox>
                        </div>
                        <div className="formRow">
                            <ToggleSwitch
                                name={"blocked"}
                                value={selectedUser.blocked == undefined ? "false" : selectedUser.blocked.toString()}
                                checked={selectedUser.blocked == undefined ? false : selectedUser.blocked}
                                label={"Blocked"}
                                returnFunc={(field: string, value: any) => {
                                    updateBooleanValue(field, value);
                                }}
                            ></ToggleSwitch>
                        </div>
                        <div className="formRow">
                            <ToggleSwitch
                                name={"disableAssignment"}
                                value={
                                    selectedUser.disableAssignment == undefined
                                        ? "false"
                                        : selectedUser.disableAssignment.toString()
                                }
                                checked={
                                    selectedUser.disableAssignment == undefined ? false : selectedUser.disableAssignment
                                }
                                label={"Disable Assignment"}
                                returnFunc={(field: string, value: any) => {
                                    updateBooleanValue(field, value);
                                }}
                            ></ToggleSwitch>
                        </div>
                        <div className="textAreaRow">
                            <TextArea
                                id={"legacyUserSettings"}
                                label="Legacy User Settings"
                                value={selectedUser.legacyUserSettings}
                                onChange={(field: string, value: any) => {
                                    updateValue(field, value);
                                }}
                                height="350px"
                                maxLength={1000}
                                errorMessage={
                                    validationErrors.find(x => x == "legacyUserSettings")
                                        ? "Field must be less than 1000 characters"
                                        : ""
                                }
                                validationFunc={lengthIsLessThan}
                            ></TextArea>
                        </div>
                        <div className="formRow">
                            <Dropdown
                                name="departmentID"
                                label="Department"
                                value={
                                    selectedUser.departmentID == undefined ? "" : selectedUser.departmentID.toString()
                                }
                                returnFunc={updateValue}
                                Valid={true}
                                options={departments.map(items => {
                                    return { label: items.name, value: items.id.toString() };
                                })}
                            ></Dropdown>
                        </div>
                        <div className="formRow">
                            <Dropdown
                                name="legacyRoleID"
                                label="Legacy Role ID"
                                value={
                                    selectedUser.legacyRoleID == undefined ? "" : selectedUser.legacyRoleID.toString()
                                }
                                returnFunc={updateValue}
                                Valid={true}
                                options={[
                                    { label: "Administrator", value: "1" },
                                    { label: "CRM", value: "2" },
                                    { label: "SCM", value: "3" },
                                    { label: "CRC", value: "4" },
                                    { label: "View All", value: "5" },
                                    { label: "View", value: "6" },
                                ]}
                            ></Dropdown>
                        </div>
                        <div className="formRow">
                            <Dropdown
                                name="globalRoleID"
                                label="Global Role ID"
                                value={
                                    selectedUser.globalRoleID == undefined ? "" : selectedUser.globalRoleID.toString()
                                }
                                returnFunc={updateValue}
                                Valid={true}
                                options={globalRoles.map(items => {
                                    return { label: items.name, value: items.id.toString() };
                                })}
                            ></Dropdown>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
export default Profile;
